export function normalizeApiBaseUrl(value: string): string {
  const trimmed = value.trim().replace(/\/$/, '');
  return trimmed.replace(/\/api$/, '');
}
